<script setup lang="ts">
defineProps<{
  showLoginButton: boolean
  hideStepIndicator?: boolean
  step: string
  redirectUrl: string
  activeStep: string
}>()

const { isAuthorized, user, login, loginUrl } = useAuth()
const { activeProduct } = storeToRefs(useProductVariantsStore())
const isFeatureEnabled = useFeatureFlag()

const isLoginPage = computed(() => useRoute().name === "login")
</script>

<template>
  <UStep
    :hide-step-indicator="hideStepIndicator"
    :is-active-step="activeStep === step"
  >
    <template #step>
      {{ step }}
    </template>
    <template #title>
      <p
        v-if="isAuthorized"
      >
        Logget inn som {{ user?.fullName }}
      </p>
      <p v-else>
        Logg inn eller registrer deg med Vipps
      </p>
    </template>
    <template #content>
      <div
        v-if="showLoginButton && !isAuthorized"
        class="flex flex-col gap-7 font-national2 text-darker md:gap-10"
      >
        <a
          v-wave
          class="block w-fit rounded-full"
          :href="loginUrl"
          @click.prevent="login('vipps', redirectUrl)"
        >
          <img
            src="/images/vipps-logginn.svg"
            alt="Logg inn med Vipps"
            class="h-18"
          />
        </a>
        <div>
          Har du ikke Vipps?
          <a
            href="https://vipps.no/hjelp/vipps/kom-i-gang-med-vipps/hvordan-skaffer-jeg-meg-vipps/"
            target="_blank"
            class="font-[inherit] underline"
            aria-label="Kom i gang med Vipps"
          >Slik går du frem.</a>
        </div>
        <p v-if="activeProduct?.productKey === 'innfoering-i-psykologi' && isLoginPage && isFeatureEnabled">
          Har du fått Feide-tilgang via din institusjon,
          <a
            class="cursor-pointer font-[inherit] underline"
            data-pendo="login-feide"
            aria-label="Feide-innlogging"
            @click.prevent="login('feide', redirectUrl)"
          >
            logg inn her.
          </a>
        </p>

        <div v-if="!isAuthorized" class="font-national2">
          <p>
            Ved å logge inn og registerere deg som bruker på Kunne,
            samtykker du til vår
            <NuxtLink class="underline" :to="{ name: 'om-path', params: { path: 'personvern' } }">
              personvernerklæring
            </NuxtLink>.
          </p>
          <br />
        </div>
      </div>
    </template>
  </UStep>
</template>
